import { ISideTreeInformation } from "../../../interfaces";

// Components
import DefaultVariant from "./DefaultVariant";

export default function InformationVariant(props: Readonly<ISideTreeInformation>) {
	const { variant = "default" } = props;

	if (variant === "default" || variant === "ordinal" || !variant) {
		return <DefaultVariant {...props} />;
	}
	return null;
}
